import { render, staticRenderFns } from "./resume-recommendations.vue?vue&type=template&id=88a50f06&"
import script from "./resume-recommendations.vue?vue&type=script&lang=js&"
export * from "./resume-recommendations.vue?vue&type=script&lang=js&"
import style0 from "./resume-recommendations.vue?vue&type=style&index=0&id=88a50f06&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports